"use client"
import { useState, useEffect } from "react"
import { User, Edit, Plus, Lock, Unlock, Search } from "lucide-react"
import axios from "axios" 
interface WebUser {
  userId: number
  userName: string
  userLogin: string
  userStatus: string
  userStore: string
  userEmail: string
  statusId: number
  isBlocked: boolean
  role: "admin" | "user"
  status: "active" | "blocked"
}

export default function WebUserManagement() {
  const [users, setUsers] = useState<WebUser[]>([])
  const [filteredUsers, setFilteredUsers] = useState<WebUser[]>([])
  const [loading, setLoading] = useState(true)
  const [searchTerm, setSearchTerm] = useState("")

  // Modal state
  const [showAddForm, setShowAddForm] = useState(false)
  const [editingUser, setEditingUser] = useState<WebUser | null>(null)

  // Form fields
  const [userName, setUserName] = useState("")
  const [userStore, setUserStore] = useState("")
  const [userEmail, setUserEmail] = useState("")
  const [userRole, setUserRole] = useState("1")
  const [errors, setErrors] = useState<{ [key: string]: string }>({})
  const [submitting, setSubmitting] = useState(false)
  const [popupMessage, setPopupMessage] = useState<string>("")

  const fetchUsers = async () => {
      try {
        //const response = await axios.get(`https://qaacsstoreapi.acsouth.com:443/api/userinfo`)
        // const response = await axios.get(`https://devprodapi.acsouth.com:443/api/userinfo`)
        //'PRODUCTION'
        const response = await axios.get(`https://acsstoreapi.acsouth.com:443/api/userinfo`)
        const data = response.data

        if (Array.isArray(data)) {
          const mappedUsers: WebUser[] = data.map((user: any) => ({
            userId: user.UserId,
            userName: user.UserName,
            userLogin: user.UserLogin,
            userStatus: user.UserStatus,
            userStore: user.UserStore,
            userEmail: user.UserEmail,
            statusId: user.StatusId,
            isBlocked: user.IsBlocked,
            role: user.StatusId === 2 ? "admin" : "user",
            status: user.IsBlocked === true ? "blocked" : "active",
          }))
          setUsers(mappedUsers)
          setFilteredUsers(mappedUsers)
        } else {
          setUsers([])
          setFilteredUsers([])
        }
      } catch (error) {
        console.error("Error fetching user info:", error)
      } finally {
        setLoading(false)
      }
    }

  useEffect(() => { 
    fetchUsers()
  }, [])

  const handleSearch = () => {
    if (!searchTerm.trim()) {
      setFilteredUsers(users)
      return
    }
    const term = searchTerm.toLowerCase()
    const filtered = users.filter((user) => {
      return (
        (user.userName?.toLowerCase() ?? "").includes(term) ||
        (user.userLogin?.toLowerCase() ?? "").includes(term) ||
        (user.userEmail?.toLowerCase() ?? "").includes(term) ||
        (user.role?.toLowerCase() ?? "").includes(term) ||
        (user.userStore?.toLowerCase() ?? "").includes(term) ||
        (user.status?.toLowerCase() ?? "").includes(term)
      )
    })
    setFilteredUsers(filtered)
  }

  //  API call to block/unblock user
  const handleBlockUser = async (user: WebUser) => {
    try {

      const payload = { 

        Operation :  "Block",
        Id:user.userId,
        Login:user.userName,
        Password:userName,
        Store:user.userStore,
        Status:user.statusId,
        Name:userName,
        Block:  user.status === "active" ? 1 : 0 ,
        Email: userEmail
      }
debugger;
      //await axios.post("https://qaacsstoreapi.acsouth.com:443/api/manageuser", payload)
      await axios.post("https://devprodapi.acsouth.com:443/api/manageuser", payload)

      setUsers(
        users.map((u) =>
          u.userId === user.userId
            ? { ...u, status: user.status === "active" ? "blocked" : "active" }
            : u
        )
      )
      setFilteredUsers(
        filteredUsers.map((u) =>
          u.userId === user.userId
            ? { ...u, status: user.status === "active" ? "blocked" : "active" }
            : u
        )
      )
    } catch (error) {
      console.error("Error blocking/unblocking user:", error)
    }
  }

  // Reset modal fields
  const resetForm = () => {
    setUserName("")
    setUserStore("")
    setUserEmail("")
    setUserRole("1")
    setErrors({})
    setEditingUser(null)
  }

  // Validation
  const validateForm = () => {
    const newErrors: { [key: string]: string } = {}
    if (!userName.trim()) newErrors.userName = "User Name is required"
    if (!userStore.trim()) newErrors.userStore = "Store Name is required"
    else if (userStore !== "" && !/^\d+$/.test(userStore)) newErrors.userStore = "Store name should be in numbers"
    if (!userEmail.trim()) newErrors.userEmail = "Email is required"
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userEmail)) newErrors.userEmail = "Invalid email format"
    if (!userRole) newErrors.userRole = "Role is required"
    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  //  Add/Update API call
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!validateForm()) return

    setSubmitting(true)
    try {
      const payload = { 

        Operation :editingUser ? "Update" : "New",
        Id:editingUser?.userId ?? 0,
        Login:userName,
        Password:userName,
        Store:userStore,
        Status:userRole,
        Name:userName,
        Block: "0",
        Email: userEmail
      }

      debugger;
       await axios.post("https://qaacsstoreapi.acsouth.com:443/api/manageuser", payload)
      //await axios.post("https://devprodapi.acsouth.com:443/api/manageuser", payload)

      setPopupMessage(`User ${editingUser  ? "updated" : "saved"} successfully!`)
      setTimeout(() => setPopupMessage(""), 3000) // Hide after 3s

      fetchUsers();

      setShowAddForm(false)
      resetForm()
    } catch (error) { 
      console.error("Error saving user:", error)
      setPopupMessage("Error saving user!")
      setTimeout(() => setPopupMessage(""), 3000)
    } finally {
      setSubmitting(false)
    }
  }

  if (loading) return <p>Loading...</p>

  return (
    <div className="p-4 lg:p-6">
      <div className="max-w-6xl mx-auto">
        
        
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-6">
       
        {/* Popup Message */}
      {popupMessage && (
        <div className="fixed top-4 left-1/2 transform -translate-x-1/2 bg-green-500 text-white px-6 py-3 rounded-lg shadow-lg z-50">
          {popupMessage}
        </div>
      )}

          <h1 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-4 lg:mb-0">Web User Management</h1>
         

          <button
            type="button"
            onClick={() => {
              resetForm()
              setShowAddForm(true)
            }}
            className="flex items-center bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors"
          >
            <Plus className="h-4 w-4 mr-2" />
            Add New User
          </button>
        </div>

        {/* Search */}
        <div className="mb-6 flex space-x-2 items-center">
          <div className="relative flex-grow">
            <Search className="h-5 w-5 text-gray-400 absolute left-3 top-1/2 transform -translate-y-1/2" />
            <input
              type="text"
              placeholder="Search..."
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <button
            type="button"
            onClick={handleSearch}
            className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors"
          >
            Search
          </button>
        </div>

        {/* Users Table */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">User</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Role</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {filteredUsers.map((user) => (
                  <tr key={user.userId} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <User className="h-8 w-8 text-gray-400 mr-3" />
                        <div>
                          <div className="text-sm font-medium text-gray-900">{user.userName}</div>
                          <div className="text-sm text-gray-500">{user.userEmail}</div>
                          <div className="text-xs text-gray-400">@{user.userLogin}</div>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span
                        className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                          user.role === "admin" ? "bg-purple-100 text-purple-800" : "bg-blue-100 text-blue-800"
                        }`}
                      >
                        {user.role}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span
                        className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                          user.status === "active" ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"
                        }`}
                      >
                        {user.status}
                      </span>
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                      <div className="flex space-x-2">
                        <button
                          type="button"
                          onClick={() => {
                            setEditingUser(user)
                            setUserName(user.userName)
                            setUserStore(user.userStore)
                            setUserEmail(user.userEmail)
                            setUserRole(user.statusId.toString())
                            setShowAddForm(true)
                          }}
                          className="text-blue-600 hover:text-blue-900"
                        >
                          <Edit className="h-4 w-4" />
                        </button>
                        <button
                          type="button"
                          onClick={() => handleBlockUser(user)}
                          className={
                            user.status === "active"
                              ? "text-red-600 hover:text-red-900"
                              : "text-green-600 hover:text-green-900"
                          }
                        >
                          {user.status === "active" ? <Lock className="h-4 w-4" /> : <Unlock className="h-4 w-4" />}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Add/Edit User Modal */}
        {(showAddForm || editingUser) && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-md">
              <h2 className="text-xl font-bold mb-4">{editingUser ? "Edit User" : "Add New User"}</h2>
              <form className="space-y-4" onSubmit={handleSubmit}>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">User Name</label>
                  <input
                    type="text"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                    className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                      errors.userName ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-blue-500"
                    }`}
                  />
                  {errors.userName && <p className="text-red-500 text-xs mt-1">{errors.userName}</p>}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Store Name</label>
                  <input
                    type="text"
                    value={userStore}
                    onChange={(e) => setUserStore(e.target.value)}
                    className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                      errors.userStore ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-blue-500"
                    }`}
                  />
                  {errors.userStore && <p className="text-red-500 text-xs mt-1">{errors.userStore}</p>}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                  <input
                    type="email"
                    value={userEmail}
                    onChange={(e) => setUserEmail(e.target.value)}
                    className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                      errors.userEmail ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-blue-500"
                    }`}
                  />
                  {errors.userEmail && <p className="text-red-500 text-xs mt-1">{errors.userEmail}</p>}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Role</label>
                  <select
                    value={userRole}
                    onChange={(e) => setUserRole(e.target.value)}
                    className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                      errors.userRole ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-blue-500"
                    }`}
                  >
                    <option value="">-- Select Role --</option>
                    <option value="1">User</option>
                    <option value="2">Admin</option>
                  </select>
                  {errors.userRole && <p className="text-red-500 text-xs mt-1">{errors.userRole}</p>}
                </div>

                <div className="flex space-x-3 pt-4">
                  <button
                    type="button"
                    onClick={() => {
                      setShowAddForm(false)
                      resetForm()
                    }}
                    className="flex-1 px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={submitting}
                    className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
                  >
                    {submitting ? "Saving..." : editingUser ? "Update" : "Add"} User
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div> 
    </div>
  )
}
